<template>
  <div class="vip-contract">
    <nav-bar navBarTitle="用户协议"></nav-bar>
    <div class="content">
      <div class="content-detail" id="contentDetail" v-html="content">
      </div>
    </div>
  </div>
</template>
<script>
import { reqContract } from '../../api/api_base';

export default {
  data() {
    return {
      content: ""
    };
  },
  mounted() {
    this.getContractInfo();
  },
  methods: {
    // 获取后台协议内容
    getContractInfo() {
      reqContract({code: 'POLICY_VIP_USER_AGREEMENT'}).then(res => {
        this.content = res.data.content
        document.getElementById("contentDetail").innerHTML =  this.content
      })
    }
  }
};
</script>
<style lang="less" scoped>
.vip-contract {
  padding: 16px;
}
</style>
